import sidebar_wine from "../../assets/admin/sidebar_wine.svg";
import mapPoint from "../../assets/admin/map-point.svg";
import sidebar_restaurant from "../../assets/admin/sidebar_restaurant.svg";
import orderIcon from "../../assets/admin/order.svg";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { toast } from "react-toastify";
import { RiArrowDownSLine } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { FaSyncAlt } from "react-icons/fa";
import TableLoader from "../../utils/TableLoader";
import Loader from "../../utils/Loader";
import axios from "axios";
import { TbEdit } from "react-icons/tb";
import { motion, AnimatePresence } from "framer-motion";
import DashboardTooltip from "./Components/DashboardTooltip";

const Dashboard = (props, ref) => {
  const { hasPermission } = props;

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState({
    main: false,
    edit: false,
    sync: false,
    sync2: false,
    sync3: false,
    sync4: false,
    sync5: false,
  });

  const [isDialog, setIsDialog] = useState({
    dialog: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialog5: false,
  });

  const [numberData, setNumberData] = useState([]);
  const [restaurantData, setRestaurantData] = useState([]);
  const [currentData, setCurrentData] = useState([]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile_phone, setMobilePhone] = useState("");
  const [selectedState, setSelectedState] = useState("Active");

  const [isEditing, setIsEditing] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showOption, setShowOption] = useState({ status: false });

  const status = ["Active", "Inactive"];

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 },
    },
  };

  const dropdownVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
      opacity: 1,
      height: "auto",
      transition: { duration: 0.2 },
    },
  };

  const toggleDropdown = (dropdownName) => {
    setShowOption({
      status: dropdownName === "status" ? !showOption.status : false,
    });
  };

  const handleStateSelect = (status) => {
    setSelectedState(status);
    setShowOption({ status: false });
  };

  const getSyncData1 = async () => {
    setIsLoading((prev) => ({ ...prev, sync: true }));
    try {
      const response = await axios.get(`${apiUrl}/api/v1/import-restaurants`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        getDashboardData(); // Refresh data after sync
      }
    } catch (error) {
      toast.error("Error Syncing Restaurant Data", {
        theme: "colored",
        autoClose: 2000,
      });
      console.error("Error Syncing Restaurant data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, sync: false }));
    }
  };

  const getSyncData2 = async () => {
    setIsLoading((prev) => ({ ...prev, sync2: true }));
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/import-wines?token=dmJhc4YX0K6g15YweCzXby93KoQ7cAqPEKrXaJ80pfKvyVLo3FkNSiXuIPTB`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        getDashboardData(); // Refresh data after sync
      }
    } catch (error) {
      toast.error("Error Syncing Wine Data", {
        theme: "colored",
        autoClose: 2000,
      });
      console.error("Error Syncing Wine Data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, sync2: false }));
    }
  };

  const getSyncData3 = async () => {
    setIsLoading((prev) => ({ ...prev, sync3: true }));
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/get-wine-orders-and-process`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        getDashboardData(); // Refresh data after sync
      }
    } catch (error) {
      toast.error("Error Syncing Order Data", {
        theme: "colored",
        autoClose: 2000,
      });
      console.error("Error Syncing Order Data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, sync3: false }));
    }
  };

  /* const getSyncData4 = async () => {
    setIsLoading((prev) => ({ ...prev, sync4: true }));
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/zoho-crm/sync-restaurants`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            phase: "phase2",
            limit: 25,
          },
        },
      );
      if (response.status === 200) {
        const summary = response?.data?.summary?.phase2;

        if (!summary) {
          toast.error("No summary data returned from server.", {
            theme: "colored",
            autoClose: 3000,
          });
        } else if (summary?.processed === 0) {
          toast.error("No pending restaurants found to match.", {
            theme: "colored",
            autoClose: 3000,
          });
        } else if (summary?.errors > 0) {
          toast.error(
            `Sync finished with errors. Matched: ${summary?.matched}, Failed: ${summary?.errors}`,
            {
              theme: "colored",
              autoClose: 3000,
            },
          );
        } else {
          toast.success(
            `Bulk match complete! Successfully matched ${summary?.matched} out of ${summary?.processed} restaurants.`,
            {
              theme: "colored",
              autoClose: 3000,
            },
          );
        }
        getDashboardData();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Error Syncing Zoho Corrispondenza Data",
        {
          theme: "colored",
          autoClose: 2000,
        },
      );
      console.error("Error Syncing Zoho Corrispondenza Data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, sync4: false }));
    }
  };

  */ 
  const getSyncData5 = async () => {
    setIsLoading((prev) => ({ ...prev, sync5: true }));
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/zoho-crm/sync-restaurants`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            phase: "phase3",
            limit: 25,
          },
        },
      );
      if (response.status === 200) {
        const summary = response?.data?.summary?.phase3;

        if (!summary) {
          toast.error("No summary data returned from server.", {
            theme: "colored",
            autoClose: 3000,
          });
        } else if (summary?.processed === 0) {
          toast.error("No unmatched restaurants found. Everything is caught up!", {
            theme: "colored",
            autoClose: 3000,
          });
        } else if (summary?.failed > 0) {
          toast.error(
            `Creation finished with errors. Created: ${summary?.created}, Failed: ${summary?.failed}. Please check ERP data.`,
            {
              theme: "colored",
              autoClose: 3000,
            },
          );
        } else {
          toast.success(
            `Successfully created ${summary?.created} new accounts in ZOHO!`,
            {
              theme: "colored",
              autoClose: 3000,
            },
          );
        }
        getDashboardData();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "Error Syncing Zoho Account Creation Data",
        {
          theme: "colored",
          autoClose: 2000,
        },
      );
      console.error("Error Syncing Zoho Account Creation Data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, sync5: false }));
    }
  };

  const getDashboardData = async () => {
    setIsLoading((prev) => ({ ...prev, main: true }));
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const params = {
        pageNumber: page,
        size: rowsPerPage,
      };

      // Fetch Number stock data
      const responseNumberData = await axios.get(
        `${apiUrl}/api/v1/admin-dashboard-data`,
        {
          headers,
        },
      );
      setNumberData(responseNumberData.data);

      // Fetch restaurant data
      const responseRestaurantData = await axios.get(
        `${apiUrl}/api/v1/restaurants-latest`,
        {
          headers,
          params,
        },
      );
      const restaurantData = responseRestaurantData.data;
      setRestaurantData(restaurantData.data);
      setTotalPages(restaurantData.total);
    } catch (error) {
      toast.error("Error fetching dashboard data", {
        theme: "colored",
        autoClose: 2000,
      });
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, main: false }));
    }
  };

  const handleSave = async () => {
    setIsLoading((prev) => ({ ...prev, edit: true }));
    try {
      // Add your save logic here
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate API call
      toast.success("Restaurant updated successfully", {
        theme: "colored",
        autoClose: 2000,
      });
      setIsEditing(false);
      getDashboardData(); // Refresh data after edit
    } catch (error) {
      toast.error("Error updating restaurant", {
        theme: "colored",
        autoClose: 2000,
      });
      console.error("Error updating restaurant:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, edit: false }));
    }
  };

  const handleEditClick = (restaurant) => {
    setIsEditing(true);
    setCurrentData(restaurant);
    // Smooth scroll to edit form
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useImperativeHandle(ref, () => ({
    dashboard() {
      setIsEditing(false);
      setCurrentData(null);
    },
  }));

  const handleCancel = () => {
    setIsEditing(false);
    setCurrentData(null);
  };

  useEffect(() => {
    if (currentData) {
      setName(currentData?.company_name || "");
      setEmail(currentData?.email || "");
      setMobilePhone(currentData?.mobile_phone || "");
      setSelectedState(currentData?.status || "Active");
    }
  }, [currentData]);

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <div className="h-full">
      <AnimatePresence mode="wait">
        {!isEditing ? (
          <motion.div
            key="dashboard"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="h-full"
          >
            <section className="relative grid xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 lg:gap-6 gap-4">
              {/* Stats Cards */}
              {["wine", "region", "restaurant", "order"].map((type, index) => (
                <motion.div
                  key={type}
                  variants={cardVariants}
                  initial="hidden"
                  animate="visible"
                  transition={{ delay: index * 0.1 }}
                  className="flex justify-between items-center bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] text-[#8B2433] 2xl:px-8 px-5 rounded-2xl shadow py-4 w-full hover:shadow-md transition-shadow"
                >
                  <div className="bg-white rounded-full w-[60px] h-[60px] flex justify-center items-center transition-transform hover:scale-105">
                    <img
                      src={
                        type === "wine"
                          ? sidebar_wine
                          : type === "region"
                            ? mapPoint
                            : type === "restaurant"
                              ? sidebar_restaurant
                              : orderIcon
                      }
                      height={20}
                      width={20}
                      alt={type}
                      className="w-[25px] h-[25px] object-contain"
                    />
                  </div>
                  <div className="text-right">
                    <h3 className="md:text-base text-sm font-bold poppins-medium">
                      {type === "wine"
                        ? "N. Prodotti"
                        : type === "region"
                          ? "Regioni"
                          : type === "restaurant"
                            ? "N. Ristoranti"
                            : "N. Ordini"}
                    </h3>
                    <div className="flex items-center justify-end gap-2">
                      {type === "order" &&
                        numberData?.todayOrders !== undefined &&
                        numberData?.todayOrders !== null && (
                          <span
                            className="inline-flex items-center gap-1.5 text-[10px] 2xl:text-[11px] font-semibold text-[#8B2433] bg-[#8B243314] border border-[#8B243326] px-2 py-0.5 rounded-full whitespace-nowrap shadow-xs"
                            title="Ordini effettuati oggi"
                          >
                            <span className="w-1.5 h-1.5 rounded-full bg-[#8B2433] animate-pulse"></span>
                            <span>
                              Oggi: <strong className="font-bold">{numberData.todayOrders}</strong>
                            </span>
                          </span>
                        )}
                      <p className="text-right font-sans font-extrabold sm:text-2xl text-xl poppins-medium">
                        {(() => {
                          const count =
                            type === "wine"
                              ? numberData?.totalWines
                              : type === "region"
                                ? numberData?.totalRegion
                                : type === "restaurant"
                                  ? numberData?.totalRestaurants
                                  : numberData?.totalOrders;
                          return count !== undefined && count !== null && count !== ""
                            ? `${count}+`
                            : "-";
                        })()}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </section>

            <section>
              <div className="flex items-center justify-between pt-8 lg:flex-row flex-col my-5 gap-3">
                <motion.h3
                  className="text-[20px] leading-[26px]  2xl:text-2xl 2xl:leading-[30px] font-bold poppins-medium self-start"
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  Ristoranti Recenti
                </motion.h3>

                <motion.div
                  className="flex gap-3 self-start m-0 items-center md:flex-row flex-col md:w-auto w-full"
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3 }}
                >
                  {[
                    /* {
                      id: "sync4",
                      label: "Zoho Sync - Corrispondenza",
                      loading: isLoading.sync4,
                      dialog: isDialog.dialog4,
                      dialogKey: "dialog4",
                      confirmLabel: "Zoho Corrispondenza",
                      action: getSyncData4,
                    }, */
                    {
                      id: "sync5",
                      label: "Zoho Sync - Creazione dell'account",
                      loading: isLoading.sync5,
                      dialog: isDialog.dialog5,
                      dialogKey: "dialog5",
                      confirmLabel: "Zoho Account Creation",
                      action: getSyncData5,
                    },
                    {
                      id: "sync3",
                      label: "Sincronizza Ordini",
                      loading: isLoading.sync3,
                      dialog: isDialog.dialog3,
                      dialogKey: "dialog3",
                      confirmLabel: "Order",
                      action: getSyncData3,
                    },
                    {
                      id: "sync",
                      label: "Importa dati clienti/ristoranti",
                      loading: isLoading.sync,
                      dialog: isDialog.dialog,
                      dialogKey: "dialog",
                      confirmLabel: "Restaurant",
                      action: getSyncData1,
                    },
                    {
                      id: "sync2",
                      label: "Importa dati vino",
                      loading: isLoading.sync2,
                      dialog: isDialog.dialog2,
                      dialogKey: "dialog2",
                      confirmLabel: "Wine",
                      action: getSyncData2,
                    },
                  ].map((btn) => (
                    <div key={btn.id} className="md:w-auto w-full">
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className={`md:w-auto w-full justify-start md:justify-center flex text-[14px] leading-[20px] 2xl:text-[16px] 2xl:leading-[22px] items-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] transition-colors group ${
                          btn.loading
                            ? "opacity-75 cursor-not-allowed"
                            : "hover:text-[#8A2533] hover:bg-[#f6efef]"
                        }`}
                        onClick={() =>
                          setIsDialog({
                            ...isDialog,
                            [btn.dialogKey]: true,
                          })
                        }
                        disabled={btn.loading}
                      >
                        {btn.loading ? (
                          <svg
                            aria-hidden="true"
                            className="w-4 h-4 text-gray-50 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        ) : (
                          <FaSyncAlt
                            size={"15px"}
                            className="group-hover:invert-0 transition-transform group-hover:rotate-180"
                          />
                        )}
                        <span className="ml-2 poppins-regular">
                          {btn.label}
                        </span>
                      </motion.button>

                      <AnimatePresence>
                        {btn.dialog && (
                          <motion.div
                            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                          >
                            <motion.div
                              className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]"
                              initial={{ scale: 0.9, opacity: 0 }}
                              animate={{ scale: 1, opacity: 1 }}
                              exit={{ scale: 0.9, opacity: 0 }}
                            >
                              <div className="px-6 py-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                  Are you sure you want to sync the{" "}
                                  {btn.confirmLabel} data?
                                </h3>
                              </div>
                              <div className="px-6 py-4 flex justify-end space-x-4">
                                <motion.button
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                  onClick={async () => {
                                    await btn.action();
                                    setIsDialog((prev) => ({
                                      ...prev,
                                      [btn.dialogKey]: false,
                                    }));
                                  }}
                                  disabled={btn.loading}
                                  className={`px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md transition-colors ${
                                    btn.loading
                                      ? "opacity-50 cursor-not-allowed"
                                      : "hover:bg-[#f6efef] hover:text-[#8A2533]"
                                  }`}
                                >
                                  {btn.loading ? (
                                    <svg
                                      aria-hidden="true"
                                      className="w-4 h-4 animate-spin text-gray-50 fill-[#8B2433] invert"
                                      viewBox="0 0 100 101"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                      />
                                    </svg>
                                  ) : (
                                    "Yes"
                                  )}
                                </motion.button>
                                <motion.button
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                  onClick={() =>
                                    setIsDialog({
                                      ...isDialog,
                                      [btn.dialogKey]: false,
                                    })
                                  }
                                  disabled={btn.loading}
                                  className={`px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors ${
                                    btn.loading
                                      ? "opacity-50 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  No
                                </motion.button>
                              </div>
                            </motion.div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  ))}
                </motion.div>
              </div>

              <motion.div
                className="wine-main-table w-auto h-auto bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] text-[#303030] pt-3 pb-0 px-6 rounded-xl shadow overflow-hidden"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <table className="w-full text-left ristoranti_table dash-board-table">
                  <thead>
                    <tr className="border-b">
                      <th className="pb-3 text-left poppins-medium">
                        Nome Ristorante
                      </th>
                      <th className="pb-3 text-left poppins-medium">
                        Cellulare
                      </th>
                      <th className="pb-3 text-left poppins-medium">Email</th>
                      <th className="pb-3 text-left poppins-medium">Stato</th>
                      {hasPermission("Dashboard", "edit") && (
                        <th className="pb-3 text-left poppins-medium">
                          Opzioni
                        </th>
                      )}
                    </tr>
                  </thead>
                  {isLoading.main ? (
                    <TableLoader />
                  ) : (
                    <tbody>
                      {restaurantData?.length > 0 ? (
                        restaurantData?.map((restaurant, index) => (
                          <motion.tr
                            key={index}
                            className="border-b"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.1 * index }}
                          >
                            <td className="py-4 px-1 text-left poppins-regular">
                              <DashboardTooltip text={restaurant?.company_name} />
                            </td>
                            <td className="py-4 px-1 text-left poppins-regular">
                              {restaurant?.mobile_phone || "N/A"}
                            </td>
                            <td className="py-4 px-1 text-left poppins-regular">
                              <DashboardTooltip text={restaurant?.email} />
                            </td>
                            <td className="py-4 px-1 text-left poppins-regular">
                              <span
                                className={`w-[85px] text-center block py-1 px-3 rounded-full transition-colors ${
                                  restaurant?.status === "Attivo"
                                    ? "text-[#0AC83D] active_lable bg-green-100"
                                    : "text-[#EB2D2D] inactive_lable bg-red-100"
                                }`}
                              >
                                {restaurant?.status || "N/A"}
                              </span>
                            </td>
                            {hasPermission("Dashboard", "edit") && (
                              <td className="py-4 poppins-regular flex items-center justify-center">
                                <motion.button
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  className="text-red-700 flex items-center hover:text-[#8A2533] transition-colors"
                                  onClick={() => handleEditClick(restaurant)}
                                >
                                  <TbEdit size={"20px"} />
                                </motion.button>
                              </td>
                            )}
                          </motion.tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={hasPermission("Dashboard", "edit") ? 5 : 4}
                            className="py-4 text-center text-gray-500"
                          >
                            No restaurants found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </motion.div>
            </section>
          </motion.div>
        ) : (
          <motion.section
            key="edit-form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="border-t border-[#D9D9D9] sm:mt-5 mt-0 sm:pt-10 pt-5"
          >
            <motion.h3
              className="text-2xl font-bold mb-2 poppins-medium"
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
            >
              Modifica Ristorante
            </motion.h3>

            <motion.div
              className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5bg-[#f6efef] border-[2px] border-[#8B24332B] md:p-10 p-4 rounded-xl shadow-md font-sans"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.1 }}
            >
              <div className="flex flex-col gap-6">
                <div className="flex md:flex-row flex-col w-full gap-6">
                  <motion.div
                    className="flex flex-col md:w-[50%] w-full space-y-3"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2 }}
                  >
                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                      Nome:
                    </label>
                    <input
                      type="text"
                      className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#8A2533] focus:bg-[#f6efef] transition-colors"
                      value={
                        name
                          ?.replace(/[^a-zA-Z\s]/g, "")
                          .replace(/\s+/g, " ") || ""
                      }
                      onChange={(e) => setName(e.target.value)}
                    />
                  </motion.div>

                  <motion.div
                    className="flex flex-col md:w-[50%] w-full space-y-3"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                  >
                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                      Email:
                    </label>
                    <input
                      type="email"
                      className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#8A2533] focus:bg-[#f6efef] transition-colors"
                      value={email || ""}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </motion.div>
                </div>

                <div className="flex gap-6 md:flex-row flex-col">
                  <motion.div
                    className="flex flex-col md:w-[50%] w-full gap-3"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.4 }}
                  >
                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                      Stato:
                    </label>
                    <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                      <div className="border border-gray-300 rounded-3xl">
                        <motion.button
                          whileHover={{ backgroundColor: "#f6efef" }}
                          className="inline-flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                          onClick={() => toggleDropdown("status")}
                        >
                          <span className="mr-2 flex items-center gap-3 poppins-medium">
                            {selectedState === "Active"
                              ? "Attivo"
                              : selectedState === "Inactive"
                                ? "Inattivo"
                                : "Scegli Stato"}
                          </span>
                          <RiArrowDownSLine
                            className={`transform transition-transform duration-300 ${showOption.status ? "rotate-180" : ""}`}
                            size={"24px"}
                            color="#9f414f"
                          />
                        </motion.button>

                        <AnimatePresence>
                          {showOption.status && (
                            <motion.div
                              variants={dropdownVariants}
                              initial="hidden"
                              animate="visible"
                              exit="hidden"
                              className="bg-white absolute top-full mt-1 rounded-[21px] shadow-lg text-[#DB7685] w-full z-20 overflow-hidden"
                            >
                              {status
                                .filter((status) => status !== selectedState)
                                .map((status, index, array) => (
                                  <motion.label
                                    key={status}
                                    whileHover={{ backgroundColor: "#f6efef" }}
                                    className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-4 py-3 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                                    onClick={() => handleStateSelect(status)}
                                  >
                                    <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                      {status === "Active"
                                        ? "Attivo"
                                        : status === "Inactive"
                                          ? "Inattivo"
                                          : ""}
                                    </span>
                                  </motion.label>
                                ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    className="flex flex-col md:w-[50%] w-full gap-3"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <label className="text-sm font-semibold poppins-medium text-[#404040]">
                      Numero di cellulare:
                    </label>
                    <input
                      type="number"
                      className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#8A2533] focus:bg-[#f6efef] transition-colors"
                      value={mobile_phone || ""}
                      onChange={(e) => setMobilePhone(e.target.value)}
                    />
                  </motion.div>
                </div>
              </div>

              <motion.div
                className="flex text-sm sm:flex-row flex-col justify-start gap-3 mt-6"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                {isLoading.edit ? (
                  <motion.button
                    disabled
                    className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group opacity-75 cursor-not-allowed"
                  >
                    <svg
                      aria-hidden="true"
                      className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    Loading...
                  </motion.button>
                ) : (
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="sm:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                    onClick={handleSave}
                  >
                    <TiTick
                      size={"25px"}
                      color="green"
                      className="group-hover:invert"
                    />
                    <span className="poppins-regular">Salva</span>
                  </motion.button>
                )}

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="sm:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                  onClick={handleCancel}
                >
                  <IoClose
                    size={"25px"}
                    color="red"
                    className="group-hover:invert"
                  />
                  <span className="poppins-regular">Annulla</span>
                </motion.button>
              </motion.div>
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
};

export default forwardRef(Dashboard);